import { environment } from "src/environments/environment";

export const getThemeLang = (): any => {
  let lang;
  try {
    lang = localStorage.getItem("theme_lang") ?? environment.defaultLang;
    localStorage.setItem("direction", "ltr");
  } catch (error) {
    lang = environment.defaultLang;
    localStorage.setItem("direction", "ltr");
  }
  return lang;
};
export const setThemeLang = (lang: any, direction: any): any => {
  try {
    localStorage.setItem("theme_lang", lang);
    localStorage.setItem("direction", direction);
  } catch (error) {
    localStorage.setItem("theme_lang", environment.defaultLang);
    localStorage.setItem("direction", "ltr");
  }
};

/**
 * Normalizes an "All / none selected" dropdown value into a real number or null.
 *
 * `<ng-option [value]="null">` in ng-select hands back the **string** `"null"`,
 * not a real null. That string is truthy and is not `!== null`-clean either, so
 * an "All" selection sails past the usual guards and gets serialized into the
 * query string as `businessType=null`. The API validates these params as
 * numbers, and `Number("null")` is `NaN`, so the request is rejected with
 * `Invalid data type for parameter '<name>'. Expected 'number', got 'string'.`
 *
 * Use this whenever a dropdown value has to reach the server as a number.
 * Returns null for "All", empty, `"null"`, `"undefined"` and anything
 * unparseable — callers should omit the param entirely when they get null.
 */
export const toNumericFilter = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  // ng-select can hand back its internal NgOption wrapper rather than the bound
  // `[value]`, which serializes to the literal "[object Object]" in a query
  // string. Unwrap it — rejecting the object outright would silently downgrade a
  // real selection ("Taxi") to "All", which is worse than the 400 it prevents.
  if (typeof value === "object") {
    const wrapper = value as Record<string, unknown>;
    for (const key of ["value", "key", "id"]) {
      if (wrapper[key] !== undefined && wrapper[key] !== null) return toNumericFilter(wrapper[key]);
    }
    return null;
  }

  const raw = String(value).trim();
  if (raw === "" || raw === "null" || raw === "undefined" || raw === "NaN") return null;

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};
